import React from 'react'
import { composeClasses } from '@/utils/compose-classes'

export interface ProgressBarProps {
  progress: number
  bgColor?: string
  barBgColor?: string
  className?: string
  classNameBar?: string
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  bgColor = 'bg-[#D5D8DE]',
  barBgColor = 'bg-primary',
  className,
  classNameBar
}) => {
  return (
    <div
      data-testid="container-bar"
      className={composeClasses(bgColor, className, 'w-full h-1 rounded')}
    >
      <div
        data-testid="progress-bar"
        className={composeClasses(
          barBgColor,
          classNameBar,
          'h-full rounded-tr rounded'
        )}
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}

export default ProgressBar
